export const MIN_TAX_RATE_VALUE = 8
